// export const mainBaseUrl = 'http://localhost:5173/';
// export const apiBaseUrl = 'http://localhost/my_projects/InvoicingAiTool/PlausibleBack/';
// export const imgBaseUrl = 'http://localhost/my_projects/InvoicingAiTool/PlausibleBack/uploads/';

export const mainBaseUrl = "https://app.analytcly.ai/";
export const apiBaseUrl = 'https://api.analytcly.ai/';
export const imgBaseUrl = 'https://api.analytcly.ai/';
export const reportUrl = 'https://api.analytcly.ai/web/report/';


